export default __webpack_public_path__ + "static/media/ID-good-01.164bd3aa.png";